import { defineStore } from "pinia";
import type { Notification } from "@/types/notification";
import { NotificationType } from "@/types/notification";
import config from "@/config/env";

const SUCCESS_COLOR = "success";
const WARNING_COLOR = "warning";
const ERROR_COLOR = "error";

export const useNotificationStore = defineStore("notificationStore", {
  state: () => ({
    notification: {} as Notification,
    showNewsBadge: false,
    missionNotifCount: 0,
  }),

  getters: {
    showBadge(state) {
      return state.showNewsBadge;
    },
  },

  actions: {
    notifySuccess(message: string, color?: string) {
      this.notification = {
        active: true,
        message: message,
        color: color ?? SUCCESS_COLOR,
        type: NotificationType.Success,
        timeout: config.snackbarTimeout,
      };
    },
    notifyWarning(message: string) {
      this.notification = {
        active: true,
        message: message,
        color: WARNING_COLOR,
        type: NotificationType.Warning,
        timeout: config.snackbarTimeout,
      };
    },
    notifyError(message: string, color: string) {
      this.notification = {
        active: true,
        message: message,
        color: color ?? ERROR_COLOR,
        type: NotificationType.Error,
        timeout: config.snackbarTimeoutFailed,
      };
    },
    notifyInformation(message: string) {
      this.notification = {
        active: true,
        message: message,
        color: SUCCESS_COLOR,
        type: NotificationType.info,
        timeout: config.snackbarTimeoutFailed,
      };
    },
  },
});
